/** Clés créneau stockées en base / sessions — regroupées pour filtres admin uniquement. */
export const TIMESLOT_CATEGORIES = {
    morning: ["H8_10", "H9_11", "H10_12"],
    afternoon: ["H15_17"],
    evening: ["H19_21", "H20_22"],
} as const;

export type TimeslotCategory = keyof typeof TIMESLOT_CATEGORIES;

export const TIMESLOT_FILTER_OPTIONS: {
    label: string;
    value: TimeslotCategory;
}[] = [
    { label: "Matin", value: "morning" },
    { label: "Après-midi", value: "afternoon" },
    { label: "Soir", value: "evening" },
];

export const getTimeslotsFromFilter = (
    timeslotFilter: string | undefined
): string[] | undefined => {
    if (!timeslotFilter || timeslotFilter === "all") {
        return undefined;
    }
    const category =
        TIMESLOT_CATEGORIES[timeslotFilter as TimeslotCategory];
    if (category) {
        return [...category];
    }
    // Legacy : créneau unitaire (H8_10, …)
    return [timeslotFilter];
};
